import "./shared.scss";

const Tab = ({ tab, active, toggle, insideCard }) => (
  <li key={tab} className="nav-tab-item" onClick={() => toggle(tab)}>
    <div
      className={`nav-link-${active === tab ? "active" : "nonactive"}`}
      style={insideCard ? { color: "#68727a" } : {}}
    >
      <div className="text-capitalize">{tab}</div>
      {tab === active && <div className="nav-link-active-border" />}
    </div>
  </li>
);

const Tabs = ({ tabs = [], active, toggle, insideCard }) => {
  return (
    <ul className="page-nav-tab">
      {tabs.map((tab) => (
        <Tab
          key={tab}
          tab={tab}
          active={active}
          toggle={toggle}
          insideCard={insideCard}
        />
      ))}
    </ul>
  );
};
export default Tabs;
